import { dayjs } from '@/core/config';

/**
 * Parsea una fecha en formato string usando patrones predefinidos
 * @param date - Fecha en formato string
 * @returns Objeto dayjs válido o null si no se puede parsear
 */
export const parseDateDayjs = (date: string): dayjs.Dayjs | null => {
  const patterns = [
    { regex: /^\d{2}-\d{2}-\d{4}$/, format: 'DD-MM-YYYY' },
    { regex: /^\d{2}\/\d{2}\/\d{4}$/, format: 'DD/MM/YYYY' },
  ];

  for (const pattern of patterns) {
    if (pattern.regex.test(date)) {
      const parsedDate = dayjs(date, pattern.format, true);
      if (parsedDate.isValid()) {
        return parsedDate;
      }
    }
  }

  return null;
};

/**
 * Formatea una fecha a la zona horaria local del usuario
 * Maneja automáticamente fechas UTC sin indicador de zona horaria
 * @param date - Fecha en cualquier formato (string, number, Date)
 * @param format - Formato de salida deseado
 * @returns Fecha formateada en zona horaria local
 */
export const formatToLocalTime = (date: string | number | Date, format: string): string => {
  if (typeof date === 'string') {
    const hasTimezoneInfo = date.includes('Z') || /[+-]\d{2}:?\d{2}$/.test(date);
    const isIsoFormat = date.includes('T') && date.includes('-');
    
    if (isIsoFormat && !hasTimezoneInfo) {
      return dayjs.utc(date).local().format(format);
    }
  }
  
  return dayjs(date).local().format(format);
};
